/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import { setDataCounter } from "./setDataCounter";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * 変数設定
 */
let mediaQuery = window.matchMedia("(min-width: 1025px)").matches;
let html = document.documentElement;
let mv__img = document.querySelector(".mv img");
let logo = document.querySelector(".site-header .logo");
let globalNav__menuItem = document.querySelectorAll(".globalNav .nav__menu-item");
let snsNav = document.querySelector(".site-header .snsNav");
let address = document.querySelector(".site-header .address");
let drawerNav = document.querySelector(".drawerNav");
let logoHeight = logo.offsetHeight;
let logoTop = (window.innerHeight - logoHeight) / 2;
window.addEventListener("resize", () => {
  logoHeight = logo.offsetHeight;
  logoTop = (window.innerHeight - logoHeight) / 2;
});

/**
 * 処理
 */
const setSplash = () => {
  window.addEventListener("DOMContentLoaded", () => {
    var $myWindow = "visited";
    if (window.name.indexOf($myWindow) != -1) {
      html.classList.add("--visited");
      vistedAnimation();
      setDataCounter();
    } else {
      window.name = $myWindow;
      setTimeout(() => {
        loadingAnimation();
        setDataCounter();
      }, 1500);
    }
  });
};

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00:対象のクラスを削除
 */
function removeClass(className) {
  let willChangeItem = document.querySelectorAll("." + className);
  willChangeItem.forEach((item) => item.classList.remove(className));
}

/**
 * __00:ローディングアニメーション
 */
function loadingAnimation() {
  let tl = gsap.timeline();
  let logoMoved_yPos = mediaQuery ? 150 : 80;
  gsap.set(logo, { y: logoTop });
  tl.to(logo, { opacity: 1, duration: 1 })
    .to(mv__img, { scale: 1, clipPath: "inset(0 0 0 0)" })
    .to(logo, { y: logoMoved_yPos, duration: 1, ease: "power1.easeOut", delay: 0.2 }, ">")
    .to(globalNav__menuItem, { opacity: 1, y: 0, stagger: 0.1, duration: 1.5, ease: "Expo.easeinOut" }, "<")
    .to([snsNav, address, drawerNav], { opacity: 1, y: 0, duration: 1.5, ease: "Expo.easeinOut" }, "<")
    .to([html], {
      onComplete: () => {
        removeClass("--loading");
        removeClass("--alpha");
        removeClass("--hintBrowser");
      }
    }); // ローディングアニメーション終了
}

function vistedAnimation() {
  let tl = gsap.timeline();
  tl.to([html], {
    onComplete: () => {
      removeClass("--loading");
      removeClass("--alpha");
      removeClass("--hintBrowser");
    }
  }); // ローディングアニメーション終了
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setSplash
};